import { Form } from 'react-bulma-components';
import KeyTonicPicker from '../components/keytonic-picker';
import MarkdownTextarea from '../components/markdown-textarea';
import MarkdownTextareaAC from './markdown-textarea_ac';
import React from 'react';
import StepContent from './step-content';
import _ from 'lodash';

const { Control, Field, Input, Label, Textarea } = Form;

//import Message from 'react-bulma-components/lib/components/message';



const StepContentEdit = ({ step, statePrefix, handleChange, skipInstrumentTransponation, pageSlug }) => {

  return (
    <>
      <Field>
        <Control>
          <Label>Key tonic:</Label>
          <KeyTonicPicker name={`${statePrefix}.keytonic`} onChange={handleChange} value={step?.keytonic} />
        </Control>
      </Field>
      <Field>
        <Label>Step title</Label>
        <Control>
          <Input onChange={handleChange} name={`${statePrefix}.title`} type="text" placeholder="The title of the step" value={step?.title ?? ""} />
        </Control>
      </Field>
      <Field>
        <Label>Step description</Label>
        <Control>
          <MarkdownTextareaAC name={`${statePrefix}.description`} placeholder="Textarea" value={step?.description ?? ""} onChange={handleChange}  pageSlug={pageSlug}/>
{/*           <MarkdownTextarea name={`${statePrefix}.description`} placeholder="Textarea" value={step?.description ?? ""} onChange={handleChange}  pageSlug={pageSlug}/>
 */}        </Control>
      </Field>
       <Field>
        <Label>Step explanation</Label>
        <Control>
          <MarkdownTextareaAC name={`${statePrefix}.explanation`} placeholder="Textarea" value={step?.explanation ?? ""} onChange={handleChange}  pageSlug={pageSlug}/>
        </Control>
      </Field>
      <Label>Preview</Label>
      <StepContent header={step.title} description={step.description} explanation={step.explanation} keytonic={step.keytonic} showDetails={true} skipInstrumentTransponation={skipInstrumentTransponation} />

    </>
  )
};

export default StepContentEdit;